import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"eggplant"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4.25173 19.7495C1.42094 16.9187 2.12421 13.3897 4.24882 11.2651C6.37343 9.1405 8.84673 9.49583 10.2588 8.08374C11.2772 7.06536 12.8575 5.62012 12.8575 5.62012L13.9718 6.13986L14.5024 9.49887L17.8614 10.0295L18.3805 11.1424C18.3805 11.1424 16.9343 12.722 15.9157 13.7406C14.5036 15.1527 14.8483 17.6285 12.7341 19.7504C10.6199 21.8722 7.08253 22.5803 4.25173 19.7495Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M19.0976 12.6823L17.8604 10.0299L14.5014 9.49931L13.9708 6.1403L11.3184 4.90312C13.4269 2.79457 16.8214 2.75568 18.9773 4.78645C19.0179 4.82461 19.0579 4.8635 19.0976 4.90312C21.2457 7.05129 21.2457 10.5342 19.0976 12.6823Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12.35 6.08838C11.8 6.59853 10.9133 7.42938 10.2588 8.0839C8.84673 9.49599 6.37343 9.14066 4.24882 11.2653C2.12421 13.3898 1.42094 16.9189 4.25173 19.7497C7.08253 22.5805 10.6199 21.8724 12.7341 19.7505C14.8483 17.6287 14.5036 15.1528 15.9157 13.7408C16.5652 13.0912 17.3886 12.2137 17.9 11.663","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M19.2002 4.675L20.1582 4.196M14.5014 9.49888L13.9708 6.13986L11.3184 4.90312C13.4665 2.75495 16.9494 2.75495 19.0976 4.90312C21.2457 7.05129 21.2457 10.5342 19.0976 12.6823L17.8604 10.0295L14.5014 9.49888Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Eggplant = Vue.extend<IconProps>({
  name: 'EggplantIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'eggplant',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Eggplant;
